export default "__VITE_ASSET__519002dc__"